module.exports = __webpack_public_path__ + "img/stefan-tauber.3b9a802b.png";